<template>
	<div class="contact__dealer">
		<h3 class="font-bold text-2xl uppercase">Contact Dealer</h3>
		<loader :loading="loading"></loader>
		<form action="" method="post" class="space-y-[24px] mt-5" @submit.prevent="send" v-if="!contacted">
			<div class="text-[12px] mt-[7px]">*Required</div>
			<div class="form__group">
				<input-text v-model="contact.firstname" label="First Name" :required="true" :errors="errors.firstname"></input-text>
				<input-text v-model="contact.lastname" label="Last Name" :required="true" :errors="errors.lastname"></input-text>
			</div>
			<div class="form__group">
				<input-text v-model="contact.email" label="Email" :required="true" :errors="errors.email" inputmode="email"></input-text>
			</div>
			<div class="form__group">
				<input-text v-model="contact.phone" label="Phone" :required="true" :errors="errors.phone" inputmode="tel" v-mask="'(###) ###-####'"></input-text>
			</div>
			<div class="form__group">
				<input-textarea v-model="contact.message" label="Message" :errors="errors.message" :required="true" cols="30" rows="5"></input-textarea>
			</div>
			<div class="form__group">
				<div class="field__group">
					<input type="submit" value="Contact Dealer" />
				</div>
			</div>
		</form>
		<div class="form__notes text-[12px] mt-8" v-if="!contacted">
			By clicking "Submit", you authorize Nauticstar Boats and its dealers to contact you with marketing and sales information by emailing or calling or texting the phone number provided. This authorization is not required to make a purchase, please see our <a href="https://nauticstarboats.com/privacy-policy/" target="_blank">Privacy Policy.</a>
		</div>
		<div v-if="contacted" class="space-y-[24px] mt-5 mb-5 success-text">
			Thank you for your contact request. Your local certified dealer will contact you shortly.
		</div>
	</div>
</template>

<script>
	export default {
		props: ['boat'],
		data() {
			return {
				loading: false,
				errors: {},
				contact: {},
				contacted: false
			};
		},
		methods: {
			async send() {
				this.loading = true;
				this.errors = {};
				try {
					const res = await this.$post('/json/boats/' + this.boat.id + '/contact', this.contact);
					this.contact = {};
					this.contacted = true;
				} catch(e) {
					this.errors = e.data ?? {};
				}
				this.loading = false;
			}
		}
	}
</script>